import { getColorScheme } from "@appally/lib/utils/colorSchemes";
import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

const solid = definePartsStyle((props) => {
  const { main, light, tint, text } = getColorScheme(props.colorScheme);
  return {
    container: {
      bg: "transparent",
      padding: 2,
      // _checked: {
      //   bg: main,
      // },
    },
    control: {
      borderColor: "gray.300",
      _checked: {
        bg: main,
        borderColor: main,
        _dark: {
          bg: light,
          borderColor: light,
        },
      },
      _dark: {
        borderColor: light,
      },
    },
    label: {
      color: "gray.900",
      _dark: {
        color: "white",
      },
      _checked: {
        _dark: {
          color: text,
        },
      },
    },
  };
});

const outline = definePartsStyle((props) => {
  const { main, tint, text } = getColorScheme(props.colorScheme);
  return {
    container: {
      border: "2px solid",
      borderColor: "gray.300",
      padding: 4,
      borderRadius: 16,
      _checked: {
        borderColor: main,
        bg: tint,
      },
    },
    control: {
      borderColor: "gray.300",
      _checked: {
        bg: main,
        borderColor: main,
      },
    },
    label: {
      color: "gray.900",
      _dark: {
        color: "white",
      },
      _checked: {
        _dark: {
          color: text,
        },
      },
    },
  };
});

const gradient = definePartsStyle((props) => {
  const { main, tint, text, dark } = getColorScheme(props.colorScheme);
  return {
    container: {
      border: "none",
      padding: 4,
      rounded: "full",
      _checked: {
        bgGradient: `linear(to-r, ${dark}, ${tint})`,
      },
    },
    control: {
      borderWidth: "1px",
      mr: 2,
      borderColor: "gray.300",
      _checked: {
        bg: dark,
        borderColor: "black",
        color: "black!important",
      },
    },
    label: {
      color: "gray.900",
      fontWeight: "bold",
      _dark: {
        color: "white",
        _checked: {
          color: "gray.900",
        },
      },
    },
  };
});

export const Radio = defineMultiStyleConfig({
  variants: { solid, outline, gradient },
  defaultProps: {
    size: "lg",
    variant: "outline",
    colorScheme: "primary",
  },
});
